const NAMES = ["A", "J", "K", "T", "M", "R", "P", "S", "L", "N", "C", "D"]
const EDITOR_COLORS = ["bg-primary", "dark:bg-cyan-electric", "bg-emerald-500", "bg-amber-500", "bg-rose-500"]
const SEAT_PRICE = 15

document.querySelectorAll("[data-collab-demo]").forEach((el) => {
  const viewersEl = el.querySelector("[data-collab-viewers]")
  const editorsEl = el.querySelector("[data-collab-editors]")
  const totalEl = el.querySelector("[data-collab-total]")
  const resetBtn = el.querySelector("[data-collab-reset]")
  const addButtons = el.querySelectorAll("[data-collab-add]")

  let viewers = 3
  let editors = 1

  const avatar = (label, colorClass) => {
    const span = document.createElement("span")
    span.className = `flex h-7 w-7 items-center justify-center rounded-full text-[10px] font-bold text-white ${colorClass}`
    span.textContent = label
    return span
  }

  const render = () => {
    viewersEl.innerHTML = ""
    for (let i = 0; i < viewers; i++) {
      viewersEl.appendChild(avatar(NAMES[i % NAMES.length], "bg-slate-400 dark:bg-white/20"))
    }

    editorsEl.innerHTML = ""
    for (let i = 0; i < editors; i++) {
      editorsEl.appendChild(avatar(NAMES[i % NAMES.length], EDITOR_COLORS[i % EDITOR_COLORS.length]))
    }

    totalEl.innerHTML = `$${editors * SEAT_PRICE}<span class="text-sm font-normal text-slate-500 dark:text-slate-body">/mo</span>`
  }

  addButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.dataset.collabAdd === "viewer") {
        viewers = Math.min(viewers + 1, 24)
      } else {
        editors = Math.min(editors + 1, 12)
      }
      render()
    })
  })

  if (resetBtn) {
    resetBtn.addEventListener("click", () => {
      viewers = 3
      editors = 1
      render()
    })
  }

  render()
})
